import React from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import HomeHeroIllustration from '../../assets/svg/home.svg';
import { Container, SearchBar } from '../../components';
import { polyfill } from "seamless-scroll-polyfill";
// Use for smooth scrolling
polyfill();

const HomeHero = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const handleSmoothScroll= (event) =>{
    const anchor = (event.target.ownerDocument || document).querySelector('#course-view',);
    if (anchor) {
      anchor.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  };

  return (
    
    <Container
      maxWidth={{ sm: 800, md: 1236 }}
      marginTop={{xs:0, md:-13}}
      sx={{
        backgroundColor: theme.palette.alternate.main,
        paddingTop: 13,
        width: '100%',
      }}
    >
      <Box
        bgcolor={'alternate.main'}
        padding={{ xs: 2, md: 4 }}
        borderRadius={2}
      >
        <Grid container spacing={4}>
          <Grid
            item
            container
            xs={12}
            md={6}
            alignItems={'center'}
            sx={{ position: 'relative' }}
            data-aos={isMd ? 'fade-right' : 'fade-up'}
          >
            <Box marginBottom={4}>
              <Box marginBottom={2}>
                <Typography
                  variant="h3"
                  component={'h3'}
                  sx={{
                    fontWeight: 700,
                  }}
                >
                  Limitless learning at your&nbsp;
                  <Typography
                  color={'#24ca86'}
                  component={'span'}
                  variant={'inherit'}
                  sx={{
                    background: `linear-gradient(180deg, transparent 82%, ${alpha(
                      theme.palette.secondary.main,
                      0.6,
                    )} 90%)`,
                  }}
                  >
                    
                    fingertips
                  </Typography>
                </Typography>
              </Box>
              <Box marginBottom={3}>
                <Typography variant="h6" component="p" color="text.secondary">
                  Find the best quality tutorial with zero fee.
                </Typography>
              </Box>
              <Box
                display="flex"
                flexDirection={{ xs: 'column', sm: 'row' }}
                alignItems={{ xs: 'stretched', sm: 'flex-start' }}
              >
                <Box
                  component={Button}
                  variant="contained"
                  color="primary"
                  size="large"
                  fullWidth={!isMd}
                  maxWidth={300}
                  onClick={handleSmoothScroll}
                >
                  Explore
                </Box>
                
              </Box>
            </Box>
            <Box
              sx={{
                width: '100%',
                background: theme.palette.background.paper,
                [theme.breakpoints.up('md')]: {
                  position: 'absolute',
                  bottom: 20,
                  transform: 'translateY(100%)',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  border: '0 !important',
                },
              }}
            >
              <SearchBar />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              height={1}
              width={1}
              display={'flex'}
              justifyContent={'center'}
            >
              <Box
                height={1}
                width={1}
                maxWidth={{ xs: 600, md: '100%' }}
                maxHeight={500}
              >
                <Box
                  component={'img'}
                  src={HomeHeroIllustration}
                  width={1}
                  height={1}
                  sx={{
                    filter:
                      theme.palette.mode === 'dark'
                        ? 'brightness(0.8)'
                        : 'none',
                  }}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
      
    </Container>

  );
};

export default HomeHero;
